"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Card = _interopRequireDefault(require("../Card"));
var _MyAccountInput = _interopRequireDefault(require("../MyAccountInput"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _useMessage = _interopRequireDefault(require("../../hooks/useMessage"));
var _api = require("../../api");
var _MyAccountConsentsStyled = require("../MyAccountConsents/MyAccountConsentsStyled");
var _AddressDetailsStyled = require("./AddressDetailsStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AddressDetails = _ref => {
  let {
    data,
    isLoading,
    updateCaptureOption
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const [isSectionDisabled, setIsSectionDisabled] = (0, _react.useState)(true);
  const [isPending, setIsPending] = (0, _react.useState)(false);
  const [address, setAddress] = (0, _react.useState)(null);
  const [initialAddress, setInitialAddress] = (0, _react.useState)(null);
  const [message, type, setMessage, resetMessage] = (0, _useMessage.default)();
  (0, _react.useEffect)(() => {
    if (data) {
      setAddress(data.answer);
      setInitialAddress(data.answer);
    }
  }, [data]);
  const onAddressChange = (key, newValue) => {
    setAddress({
      ...address,
      [key]: newValue
    });
  };
  const onCancel = () => {
    setAddress(initialAddress);
    setIsSectionDisabled(true);
  };
  const onSubmit = () => {
    setIsPending(true);
    (0, _api.updateCaptureAnswers)({
      ...address
    }).then(() => {
      updateCaptureOption({
        key: 'address',
        value: address
      });
      setMessage({
        message: t('Your address details have been changed successfully'),
        type: 'success'
      });
      setIsPending(false);
      setIsSectionDisabled(true);
    }).catch(() => {
      setMessage({
        message: t('Something went wrong. Try again later.'),
        type: 'error'
      });
      setIsPending(false);
      setIsSectionDisabled(true);
    });
  };
  return isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
    isMyAccount: true
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddressDetailsStyled.WrapStyled, {
    children: address && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.default, {
      withBorder: true,
      children: [message && /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddressDetailsStyled.MessageStyled, {
        type: type,
        children: message
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountInput.default, {
        id: "address",
        label: t('Address Line 1'),
        value: address.address || '',
        onChange: e => onAddressChange('address', e.target.value),
        disabled: isSectionDisabled
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountInput.default, {
        id: "address2",
        label: t('Address Line 2'),
        value: address.address2 || '',
        onChange: e => onAddressChange('address2', e.target.value),
        disabled: isSectionDisabled
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountInput.default, {
        id: "city",
        label: t('City'),
        value: address.city || '',
        onChange: e => onAddressChange('city', e.target.value),
        disabled: isSectionDisabled
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_AddressDetailsStyled.RowStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountInput.default, {
          id: "state",
          label: t('State'),
          value: address.state || '',
          onChange: e => onAddressChange('state', e.target.value),
          disabled: isSectionDisabled
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountInput.default, {
          id: "postCode",
          label: t('Zip/Postal code'),
          value: address.postCode || '',
          onChange: e => onAddressChange('postCode', e.target.value),
          disabled: isSectionDisabled
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountConsentsStyled.ButtonWrapperStyled, {
        children: isSectionDisabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountConsentsStyled.ButtonStyled, {
          onClickFn: () => {
            setIsSectionDisabled(false);
            resetMessage();
          },
          width: "100%",
          children: t('Edit Address')
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountConsentsStyled.ButtonStyled, {
            theme: "simple",
            onClickFn: () => onCancel(),
            children: t('Cancel')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountConsentsStyled.ButtonStyled, {
            onClickFn: onSubmit,
            disabled: isPending,
            type: "submit",
            theme: "confirm",
            children: isPending && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
              buttonLoader: true,
              color: "#ffffff"
            }) || t('Save')
          })]
        })
      })]
    })
  });
};
AddressDetails.propTypes = {
  isLoading: _propTypes.default.bool,
  data: _propTypes.default.objectOf(_propTypes.default.any),
  updateCaptureOption: _propTypes.default.func
};
AddressDetails.defaultProps = {
  isLoading: false,
  data: {},
  updateCaptureOption: () => null
};
var _default = exports.default = AddressDetails;